import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxBottomBarCompositeComponent } from './rx-bottom-bar-composite.component';
import { RxButtonModule } from '@nrwl/rx-button';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxBadgeModule } from '@nrwl/rx-badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RxColModule } from '@nrwl/rx-col';
import { RxRowModule } from '@nrwl/rx-row';

@NgModule({
  imports: [
    CommonModule,
    RxButtonModule,
    RxIconModule,
    RxBadgeModule,
    MatTooltipModule,
    RxBottomBarCompositeComponent,
    RxColModule,
    RxRowModule,
  ],
  exports: [RxBottomBarCompositeComponent],
})
export class RxBottomBarCompositeModule {}
